import { Component, OnInit } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import {Observable}from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Series } from './../../models';
import { EcomicService } from '../../service/comics/ecomic.service';
declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-e-novel-series',
  templateUrl: './e-novel-series.component.html',
  styleUrls: ['./e-novel-series.component.css']
})
export class ENovelSeriesComponent implements OnInit {
  Enovelseriescol:AngularFirestoreCollection<Series>;
  Enovelseries:Observable<Series[]>;
  status: any = 'All';
  id:any;
  constructor(private afs:AngularFirestore,private comicservice:EcomicService) { }
  ngOnInit() {
    this.filterseries('All');
   }filterseries(status) {
    console.log(status);
    this.Enovelseriescol = this.afs.collection('Enovelseries', res => {
      if (status === 'All') {
        return res.orderBy('createdAt', 'desc')
      } else {
        return res.orderBy('createdAt', 'desc').where('status', '==', status);
      }
    });
    this.Enovelseries = this.Enovelseriescol.valueChanges();
    this.Enovelseries.subscribe(data => {
      console.log(data);
    });
    console.log(this.Enovelseries);
  }
  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
    this.comicservice.deleteseries('Enovelseason','novel_series',this.id).then(status =>{
      if(status){
        this.afs.doc('/Enovelseries/'+this.id).delete().then(function () {  
          swal('Deleted!', 'Your List has been deleted.', 'success');
        }).catch(function(error){
          swal('Error!', error, 'error');
          console.error("error in removing document:",error);
        });
      } else {
        swal('Error!', 'Your are not permitted to delete.', 'error');
        console.log('not permited');
        
      }
    })
     
  }

}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-series/e-novel-series.component.ts